import { render, staticRenderFns } from "./CopyTextButton.vue?vue&type=template&id=4ee2abc9&lang=pug"
import script from "./CopyTextButton.vue?vue&type=script&lang=js"
export * from "./CopyTextButton.vue?vue&type=script&lang=js"
import style0 from "./CopyTextButton.vue?vue&type=style&index=0&id=4ee2abc9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports